import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  Item_Code,
  ItemName,
  ItemDescription,
  Item_UOM,
  PackingUnit,
  PriceList,
  Customer,
  Supplier,
  BatchNo,
  Currency,
  Rate,
  ValidFrom,
  ValidUpto,
  LeadTimeindays,
  Note,
  Reference,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Input label="Item Code" readOnly value={Item_Code.select_Item_Code} style={{ height: '30px' }} />


          </div>
        </div>
        {Item_Code?.select_Item_Code && (
          <>
            <div className="col-4">
              <div className="mb-3">
                <Input
                  id="ItemName"
                  label="Item Name"
                  style={{ height: "30px" }}
                  value={ItemName?.ItemName || ""}
                  onChange={(e) => ItemName.setItemName(e.target.value)}
                  readOnly
                />


              </div>
            </div>
            <div className="col-4">
              <div className="mb-3">
                <Input
                  id="ItemDescription"
                  label="Item Description"
                  style={{ height: "30px" }}

                  value={ItemDescription?.ItemDescription || ""}
                  onChange={(e) => ItemDescription.setItemDescription(e.target.value)}
                  readOnly
                />


              </div>
            </div>


          </>

        )}
        <div className="col-4">
          <div className="mb-3">
            <Input label="UOM" readOnly value={Item_UOM.select_Item_UOM} style={{ height: '30px' }} />


          </div>

        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="PackingUnit"
              label="Packing Unit"
              style={{
                height: "30px",
                border: PackingUnit.Error ? "1px solid red" : "",
              }}
              readOnly
              value={PackingUnit.PackingUnit}
              onChange={(e) => PackingUnit.setPackingUnit(e.target.value)}
            />
            <p
              style={{
                fontSize: "9px",
                color: "#00000099",
                marginLeft: "12px",
              }}
            >
              Quantity that must be bought or sold per UOM
            </p>
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Price List Details </p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input label="Price List" readOnly value={PriceList.select_PriceList} style={{ height: '30px' }} />


          </div>

        </div>
        {PriceList?.PriceList === "Standard Selling" && (
          <div className="col-4">
            <div className="mb-3">
              <Input label="Customer" readOnly value={Customer.select_Customer} style={{ height: '30px' }} />


            </div>
          </div>
        )}
        {PriceList?.PriceList === "Standard Buying" && (
          <div className="col-4">
            <div className="mb-3">
              <Input label="Supplier" readOnly value={Supplier.select_Supplier} style={{ height: '30px' }} />


            </div>
          </div>
        )}


        <div className="col-4">
          <div className="mb-3">
            <Input label="Batch No" readOnly value={BatchNo.select_BatchNo} style={{ height: '30px' }} />

          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Currency"
              label="Currency"
              style={{
                height: "30px",
                border: Currency.Error ? "1px solid red" : "",
              }}

              value={Currency.Currency}
              onChange={(e) => Currency.setCurrency(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Rate"
              label="Rate"
              style={{
                height: "30px",
                border: Rate.Error ? "1px solid red" : "",
              }}
              value={Rate.Rate}
              onChange={(e) => Rate.setRate(e.target.value)}
              readOnly
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="ValidFrom"
              type="date"
              label="Valid From"
              style={{
                height: "30px",
                border: ValidFrom.Error ? "1px solid red" : "",
              }}
              value={ValidFrom.ValidFrom}
              onChange={(e) => ValidFrom.setValidFrom(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="ValidUpto"
              type="date"
              label="Valid Upto"
              style={{
                height: "30px",
                border: ValidUpto.Error ? "1px solid red" : "",
              }}
              value={ValidUpto.ValidUpto}
              onChange={(e) => ValidUpto.setValidUpto(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="LeadTimeindays"
              label="Lead Time in days"
              style={{
                height: "30px",
                border: LeadTimeindays.Error ? "1px solid red" : "",
              }}
              value={LeadTimeindays.LeadTimeindays}
              onChange={(e) => LeadTimeindays.setLeadTimeindays(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Textarea
              id="Note"
              label="Note"
              style={{
                height: "30px",
                border: Note.Error ? "1px solid red" : "",
              }}
              value={Note.Note}
              onChange={(e) => Note.setNote(e.target.value)}
              readOnly
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Reference"
              label="Reference"
              style={{
                height: "30px",
                border: Reference.Error ? "1px solid red" : "",
              }}
              value={Reference.Reference}
              onChange={(e) => Reference.setReference(e.target.value)}
              readOnly
            />
          </div>
        </div>
      </div>
      <div className="mt-3">
        <ActivityCard doctype="Item Price" docname={IdData} />
      </div>
    </>
  );
};

export default Tab1;
